import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Box, Typography } from '@mui/material'
import Icon from '../../utils/icons'
import { AppButton } from '../../components'
import { STATUS, SITE_STATUS, FORM_IDS } from './constants'
import { useStyles } from './style'

function FormValidation(props) {
  const classes = useStyles()
  const { obj, index } = props
  const [row, setRow] = useState(obj)

  useEffect(() => {
    setRow(obj)
  }, [obj])

  const handleClick = (index, status) => {
    const newRow = _.cloneDeep(row)
    newRow.status = status
    setRow(newRow)
    props.handleAction(index, status)
  }


  return (
    <Box className={classes.formFields}>
      <Box className={classes.rowWrapper}>
        <Typography className={classes.label}>{row.label}</Typography>
        {
          _.isArray(row.value) && !_.isEmpty(row.value)
            ? row.value.map(val => <Typography className={classes.value}>{val}</Typography>)
            : <Typography className={classes.value}>{row.value}</Typography>
        }
      </Box>
      {props.applicationStatus && (props.applicationStatus === SITE_STATUS.SITE_REJECTED || props.applicationStatus === SITE_STATUS.APPLICATION_REJECTED || props.applicationStatus === SITE_STATUS.APPLICATION_UNENROLLED)
        ? <></>
        : props.applicationStatus && (props.applicationStatus === SITE_STATUS.SITE_APPROVED || props.applicationStatus === SITE_STATUS.APPLICATION_APPROVED)
          ?
          <Box className={classes.buttonWrapper}>
            <Typography className={classes.status}>
              <span>
                <Icon src="circleTick" />
              </span>
              {STATUS.APPROVED}</Typography>
          </Box>
          : _.isEmpty(row.status) ?
            <Box className={classes.buttonWrapper}>
              <AppButton className={`${classes.button} ${classes.formButton} ${classes.approveButton}`} text="Approve" onClick={() => handleClick(index, STATUS.APPROVED)} />
              <AppButton className={`${classes.button} ${classes.formButton} ${classes.rejectButton} ${classes.formReject}`} fill={false} text="Reject" onClick={() => handleClick(index, STATUS.REJECTED)} />
            </Box>
            :
            <Box className={classes.buttonWrapper}>
              <Typography className={classes.status}>
                <span>
                  {row.status === STATUS.APPROVED ? <Icon src="circleTick" /> : <Icon src="circleCross" />}
                </span>
                {row.status === STATUS.APPROVED ? STATUS.APPROVED : STATUS.REJECTED}</Typography>
              {(props.applicationStatus === SITE_STATUS.APPLICATION_SUBMITTED || props.applicationStatus === SITE_STATUS.SITE_SUBMITTED) && <AppButton className={`${classes.button} ${classes.formButton} ${classes.rejectButton} ${classes.formReject}`} fill={false} text="Undo" onClick={() => handleClick(index, '')} />}
            </Box>
      }
    </Box>
  )
}

FormValidation.defaultProps = {
  obj: {},
  index: 0,
  handleAction: () => { }
}

export default FormValidation